import script from "./MessageDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageDropdown.vue?vue&type=script&setup=true&lang=js"

import "./MessageDropdown.vue?vue&type=style&index=0&id=4fbf4888&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fbf4888"]])

export default __exports__